/* eslint-disable @nx/enforce-module-boundaries */
import { Card } from '@mybridge/ui/card';
import { HStack, Stack } from '@mybridge/ui/layout';
import { Spinner } from '@mybridge/ui/spinner';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getAllConnectionIDs } from 'packages/mybridgev4/store/actions/connection.actions';
import {
  triggerFetchPosts,
  fetchPosts as fetchBgPosts,
  recentPosts,
} from 'packages/mybridgev4/store/actions/post.actions';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useInView } from 'react-intersection-observer';
import {
  fetchCompanyPosts,
  fetchMyActivity,
  fetchPosts,
} from 'v4/lib/api/post';
import { DashboardPostBox } from './post-box';
import { PostCardSkeleton } from 'v4/components/post/skeleton';
import { flattenQueryResults, getNextPageFromURL } from 'v4/utils/utils';
import { Avatar, AvatarGroup, Button, Text } from '@mybridge/ui';
import SectionLoader from 'v4/components/common/loader/sectionLoader';
import InfiniteScroll from 'react-infinite-scroll-component';
import { ReelsBox } from '../ReelsBox';
import { MyProfileNetworkSuggestionsCarousel } from 'v4/components/public-profile/suggestions-carousel';
import _ from 'lodash';
import { ArrowUp, ArrowUp2 } from '@mybridge/icons';
import { getUserFullName, getUserProfilePic } from 'v4/lib/commons';
import { ArrowUpIcon } from '@chakra-ui/icons';
import io from 'socket.io-client';
import { useChatSocket } from 'packages/mybridgev4/hooks/useChatSocket';

const SOCKET_SERVER_URL = process.env.SOCKET_URL;
const TOKEN_NAME = process.env.BASE_TOKEN_NAME;

export const DashboardFeed = ({
  companyDetails,
  listtype,
  displayCount,
  location,
}) => {
  const [pages, setPages] = useState([]);
  const fetching = useRef(true);
  const tid = useRef(-1);
  const tid2 = useRef(-1);
  const observerRef = useRef();
  const [inFrame, setInFrame] = useState([]);
  const [newPostItems, setNewPostItems] = useState();
  const { loggedIn } = useSelector((state) => state.user);
  const { userProfileInfo } = useSelector((state) => state.userProfile);
  const { refetchPosts, data: postDtaa } = useSelector((state) => state.posts);
  const { allConnectionIDs } = useSelector((state) => state.connection);
  const [allRecentPost, setAllRecentPost] = useState([]);
  const socketRef = useRef(null);
  const { onEvent } = useChatSocket();
  const accessToken =
  typeof window !== 'undefined' && localStorage.getItem(TOKEN_NAME);

  const dispatch = useDispatch();
  const { ref, inView } = useInView();

  // useEffect(() => {
  //   dispatch(getAllConnectionIDs());
  // }, []);

  useEffect(() => {
    if (refetchPosts) {
      refetch?.().then(() => {
        setTimeout(() => dispatch(triggerFetchPosts(false)), 100);
      });
    }
  }, [refetchPosts]);

  useEffect(() => {
    if (loggedIn && location) {
      refetch?.();
    }
  }, [loggedIn]);

  let queryFn = fetchPosts;
  if (listtype === 'company') {
    queryFn = fetchCompanyPosts;
  } else if (listtype === 'myActivity') {
    queryFn = fetchMyActivity;
  }

  /**
   * Fetch posts as infinite list
   */
  const {
    isLoading,
    isFetching,
    data = { pages: [] },
    fetchNextPage,
    refetch,
    hasNextPage,
  } = useInfiniteQuery({
    queryKey: ['dashboard-feed', companyDetails?.id, location],
    queryFn: async ({ pageParam, queryKey }) =>
      await queryFn({ pageParam, id: queryKey?.[1], location: queryKey?.[2] }),
    getNextPageParam: (lastPage, pages) => {
      return getNextPageFromURL(lastPage?.next);
    },
    refetchOnWindowFocus: false,
    cacheTime: 300000,
  });

  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(fetchBgPosts({ location }));
    }, 60000);

    // Cleanup function to clear the interval
    return () => clearInterval(intervalId);
  }, [location]);

  useEffect(() => {
    clearTimeout(tid.current);
    if (!isLoading && !isFetching) {
      tid.current = setTimeout(() => {
        fetchNextPage?.();
      }, 500);
    }
  }, [inView]);

  const filterByVisibility = (posts) => {
    const { circle, followers, following } = allConnectionIDs ?? {};
    const posts_ = [];
    for (let p of posts) {
      // Check if post is ignored by current user
      if (p.ignored_by?.includes(userProfileInfo?.id)) {
        continue; // Skip this post if user has ignored it
      }
      if (p.visibility === 0 || p?.author?.id === userProfileInfo?.id) {
        posts_?.push(p);
        continue;
      }
      const inCircle = circle?.includes?.(p?.author?.id);
      const inFollowed =
        followers?.includes?.(p?.author?.id) ||
        following?.includes?.(p?.author?.id);

      // in circle check
      // if (p.visibility === 1 && inCircle) {
      //   posts_.push(p);
      // } else if (p.visibility === 2 && (inCircle || inFollowed)) {
      //   posts_.push(p);
      // }


      // if you uncomment above code need to comment this line
      posts_.push(p);
    }
    return posts_;
  };
  const allPosts = flattenQueryResults(data) ?? [];

  
  const listingPostCount =
    data?.pages?.[data?.pageParams?.length ? data?.pageParams?.length - 1 : 0]
      ?.count ?? 0;
  const loadingPostCount = postDtaa ? postDtaa?.count : 0;

    // Initialize socket connection
    // useEffect(() => {
    //   socketRef.current = io(SOCKET_SERVER_URL, {
    //     extraHeaders: {
    //       token: `${accessToken}`,
    //     },
    //   });
  
    //   socketRef.current.on('connect', () => {
    //     // console.log('Socket connected!');
    //   });
  
    //   return () => {
    //     socketRef.current.disconnect();
    //   };
    // }, [accessToken]);
      
    
  useEffect(() => {
    // Handle new post events from socket
    const handlePostListnerEvent = (data) => {
        if(data?.author?.id === userProfileInfo?.id) return;
        
        // Use functional update to avoid stale closure issues
        setAllRecentPost((prevPosts) => {
          // Check if post already exists (deduplication by post ID)
          const postExists = prevPosts.some(post => post?.id === data?.id);
          if (postExists) {
            return prevPosts; 
          }
          
          // Add new post and limit array size to prevent memory issues (keep last 10 posts)
          const updatedPosts = [...prevPosts, data];
          return updatedPosts.slice(-10);
        });
        
        // Fetch background posts
        dispatch(fetchBgPosts({ location }));
    };

    // Set up socket event listeners
    // socketRef?.current?.on('new_post', handlePostListnerEvent);
    const unsubscribe = onEvent('new_post', handlePostListnerEvent);
    
    // Cleanup function to remove listeners when component unmounts or dependencies change
    return () => {
      // socketRef?.current?.off('new_post', handlePostListnerEvent);
      unsubscribe?.();
    };
  }, [location, userProfileInfo?.id, dispatch]);



  useEffect(() => {
    // Only proceed if we have both data sets to compare
    if (data?.pages?.[0]?.results && postDtaa?.results) {
      // Get seen post IDs from localStorage
      const seenPostIds = localStorage.getItem('seenPostIds');
      const parsedSeenPostIds = seenPostIds ? JSON.parse(seenPostIds) : [];
      
      // Filter out posts that are already in postDtaa or have been seen before
      const newPosts = _.differenceBy(
        _.filter(data?.pages?.[0]?.results, (post) => post.type !== 4),
        [...(postDtaa?.results || []), ...parsedSeenPostIds.map(id => ({ id }))],
        'id'
      );
      
      if (newPosts?.length > 0) {
        setNewPostItems(newPosts);
      }
    }
  }, [postDtaa, data?.pages]);
  // console.log(allPosts,filterByVisibility(allPosts),"djksliririri")
  useEffect(() => {
    const checkForNewPostsInterval = setInterval(() => {
      if (!isLoading && !isFetching) {
        // Silently refetch data to check for new posts
        refetch({ stale: true }).catch(err => {
          console.error("Error refetching posts:", err);
        });
      }
    }, 120000); // Check every 2 minutes
  
    return () => clearInterval(checkForNewPostsInterval);
  }, [isLoading, isFetching]);
  
  useEffect(() => {
    const intervalId = setInterval(() => {
      dispatch(fetchBgPosts({ location }));
      // After fetching background posts, check if we need to update the UI
      if (!isLoading && !isFetching) {
        refetch({ stale: true }).catch(err => {
          console.error("Error refetching posts after background fetch:", err);
        });
      }
    }, 60000);
  
    return () => clearInterval(intervalId);
  }, [location, isLoading, isFetching]);

  // Modify the handleNewPostsClick function to log before clearing
const handleNewPostsClick = () => {
  if (newPostItems?.length > 0) {
    // Dispatch action to get recent posts
    dispatch(recentPosts({ last_post_id: newPostItems[0]?.id }));
    
    // Store the seen post IDs
    const seenPostIds = localStorage.getItem('seenPostIds');
    const parsedSeenPostIds = seenPostIds ? JSON.parse(seenPostIds) : [];
    const newPostIds = newPostItems.map(post => post.id);
    localStorage.setItem('seenPostIds', JSON.stringify([...parsedSeenPostIds, ...newPostIds]));
    
    // Clear newPostItems state
    setNewPostItems(null);
    
    // Clear allRecentPost since we're loading the new posts
    setAllRecentPost([]);
    
    // Force a refetch to update the feed with new posts
    refetch().then(() => {
      // Scroll to top after refetch completes
      if (typeof window !== 'undefined') {
        window.scrollTo(0, 0);
      }
    });
  }
};


  // const FeedLoaderButton = () => {    
  //   return (
  //     <HStack
  //       bg="brandPrimary.500"
  //       borderRadius="full"
  //       h="48px"
  //       w="auto"
  //       maxW="200px"
  //       px="15px"
  //       cursor="pointer"
  //       onClick={handleNewPostsClick}
  //     >
  //       <ArrowUpIcon color="white" />
  //       <AvatarGroup color="white" size="sm" max={3}>
  //         {allRecentPost
  //           ?.filter((post, index, self) => 
  //             // Deduplicate by author ID to avoid showing same user multiple times
  //             index === self.findIndex(p => p?.author?.id === post?.author?.id)
  //           )
  //           ?.map((post, i) => (
  //             <Avatar
  //               key={`${post?.author?.id}-${post?.id}`}
  //               size="sm"
  //               fontSize="10px"
  //               src={getUserProfilePic(post?.author)}
  //               name={getUserFullName(post?.author)}
  //             />
  //           ))}
  //       </AvatarGroup>
  //     </HStack>
  //   );
  // };

  const FeedLoaderButton = () => {
    const uniqueAuthors = allRecentPost
      ?.filter((post, index, self) =>
        index === self.findIndex(p => p?.author?.id === post?.author?.id)
      )
      ?.filter(post => post?.author?.id); // ensure valid author

    if (!uniqueAuthors || uniqueAuthors.length === 0) return null; 
    
    return (
      <HStack
        bg="brandPrimary.500"
        borderRadius="full"
        h="48px"
        w="auto"
        maxW="200px"
        px="15px"
        cursor="pointer"
        onClick={handleNewPostsClick}
      >
        <ArrowUpIcon color="white" />

        <AvatarGroup size="sm" max={3}>
          {uniqueAuthors.map((post) => (
            <Avatar
              key={`${post?.author?.id}-${post?.id}`}
              size="sm"
              fontSize="10px"
              src={getUserProfilePic(post?.author) || undefined}
              name={getUserFullName(post?.author) || ' '}
            />
          ))}
        </AvatarGroup>
      </HStack>
    );
  };


  // console.log('feeds', allPosts)

  // Filter out posts from the current user to determine if button should be shown
  const newPostsFromOthers = newPostItems?.filter(
    (post) => post?.author?.id !== userProfileInfo?.id
  );

  return (
    <>
      {isLoading ? (
        <Stack spacing={6}>
          <Card p={2}>
            <PostCardSkeleton />
          </Card>
          <Card p={2}>
            <PostCardSkeleton withImage />
          </Card>
          <Card p={2}>
            <PostCardSkeleton />
          </Card>
          <Card p={2}>
            <PostCardSkeleton />
          </Card>
        </Stack>
      ) : (
        ''
      )}
      {allPosts?.length ? (
        <Stack ref={observerRef} id="observerRef" pos="relative">
          {newPostsFromOthers && newPostsFromOthers?.length > 0 && !isLoading ? (
            <HStack
              h="48px"
              pos="sticky"  
              mb="-60px"
              top={['10px', '230px']}
              left="0"
              right="0"
              zIndex="2"
              justifyContent="center"
            >
              <FeedLoaderButton />
            </HStack>
          ) : null}
          <InfiniteScroll
           style={{
            overflowX: 'hidden', // This will override the default overflow: auto
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
          }}
            dataLength={allPosts?.length}
            next={fetchNextPage}
            hasMore={!!hasNextPage}
            scrollThreshold={0.5}
            loader={
              <HStack p={4} justifyContent="center" w="100%">
                <Spinner />
              </HStack>
            }
            endMessage={
              <Text textAlign='center'>
                Yay! You have seen it all
              </Text>
            }
          >
            {filterByVisibility(allPosts)?.map((post, postIndex) => (
              <>
                {/* postIndex / 2 === Math.floor(postIndex / 2) && */}
                {postIndex === 2 && (
                  <ReelsBox postIndex={postIndex} isFirstReelSection={true} />
                )}
                {postIndex % 10 === 0 && postIndex !== 0 && (
                  <ReelsBox
                    postIndex={postIndex / 10}
                    isFirstReelSection={false}
                  />
                )}
                {postIndex === 9 && (
                  <MyProfileNetworkSuggestionsCarousel isFromDashbord={true} />
                )}

              <Card
                  id={`post_${postIndex}`}
                  className="dashboard-post"
                  // overflow="hidden"
                  key={`card-${post.id}-${post.author?.id}-${post.updated_at || post.created_at}`}
                  variant={"thinBorderedCard"}
                  m={"0px 2.5px"}
                  mt={0}
                  borderRadius="none"
                  borderTop="1px solid #e0e0e094"
                  // mb={6}
                  _hover={{
                    bg: 'rgb(245 245 245)',
                  }}
                >
                  {/* {post?.id} */}
                  <DashboardPostBox
                    key={`dashboard-post-${post.id}-${post.author?.id}-${post.updated_at || post.created_at}-${postIndex}`}
                    post={post}
                    isInFrame={inFrame.includes(`post_${postIndex}`)}
                    dashboardComments={true}
                  />
                </Card>
              </>
            ))}
          </InfiniteScroll>
        </Stack>
      ) : (
        ''
      )}
    </>
  );
};